"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const EmbeddingUrlBuilder_1 = require("./EmbeddingUrlBuilder");
function createPulseUrl(src, options, customParams) {
    // strip params in URL, all custom params should come through 'pulseOptions', 'filters' or 'customParams'.
    const srcWithoutQueryParams = src.split('?')[0];
    let url;
    try {
        url = new URL(srcWithoutQueryParams);
        EmbeddingUrlBuilder_1.validateUrl(url);
    }
    catch (error) {
        throw new api_shared_js_1.TableauError(api_external_contract_js_1.EmbeddingErrorCodes.InvalidUrl, error.message);
    }
    const defaultParams = createPulseDefaultParameters(url);
    const builder = new EmbeddingPulseUrlBuilder(url)
        .appendDefaultParameters(defaultParams)
        .appendUserOptions(options)
        .appendCustomParams(customParams);
    return builder.build();
}
exports.createPulseUrl = createPulseUrl;
function createPulseDefaultParameters(url) {
    const defaultParameters = new Map();
    const internalVersion = `${api_internal_contract_js_1.INTERNAL_CONTRACT_VERSION.major}.${api_internal_contract_js_1.INTERNAL_CONTRACT_VERSION.minor}.${api_internal_contract_js_1.INTERNAL_CONTRACT_VERSION.fix}`;
    defaultParameters.set(api_internal_contract_js_1.PulseOptionNames.ApiInternalVersion, internalVersion);
    defaultParameters.set(api_internal_contract_js_1.PulseOptionNames.embed, 'y');
    const externalVersion = api_shared_js_1.ApiVersion.Instance.formattedValue; // maj.min.fix (no build)
    defaultParameters.set(api_internal_contract_js_1.PulseOptionNames.ApiExternalVersion, externalVersion);
    defaultParameters.set(api_internal_contract_js_1.PulseOptionNames.PulseWebComponent, 'true');
    return defaultParameters;
}
class EmbeddingPulseUrlBuilder extends EmbeddingUrlBuilder_1.EmbeddingUrlBuilder {
    constructor(_url) {
        super();
        this._url = _url;
        this._optionNames = api_internal_contract_js_1.PulseOptionNames;
    }
    /**
     * Sanitizes parameter values before they are added to the search params.
     * @param parameterName The name of the parameter. Some parameters require special handling.
     * @param value The raw value of the parameter.
     */
    sanitizeParameterValue(parameterName, value) {
        return this.sanitizeValue(value);
    }
}
exports.EmbeddingPulseUrlBuilder = EmbeddingPulseUrlBuilder;
//# sourceMappingURL=EmbeddingPulseUrl.js.map